import fetch from "../utils/fetch";

// 获取指定币种的交易缓存数据（使用新的缓存接口）
export function getTradeCache(currencyId) {
  return fetch({
    url: `/api/user/binance/cache/trade/${currencyId}`,
    method: 'get'
  });
}

// 历史交易价格
export function tradeHistory(data) {
  return fetch({
    url: '/api/user/trades',
    method: 'post',
    data: data
  });
}
// 现货交易
export function spotBuy(data) {
  return fetch({
    url: '/api/user/spot-buy',
    method: 'post',
    data: data
  });
}
// 现货订单
export function spotList(data) {
  return fetch({
    url: '/api/user/spot-lists',
    method: 'post',
    data: data
  });
}
// 现货订单取消
export function cancelSpotOrder(data) {
  return fetch({
    url: '/api/user/spot-cancel',
    method: 'post',
    data: data
  });
}
// 合约订单取消
export function cancelContractOrder(data) {
  return fetch({
    url: '/api/user/contract-cancel',
    method: 'post',
    data: data
  });
}
// 模拟合约订单取消
export function cancelImitateContractOrder(data) {
  return fetch({
    url: '/api/user/virtual-contract-cancel',
    method: 'post',
    data: data
  });
}
// 期权设置
export function futuresSetting(data) {
  return fetch({
    url: '/api/user/FuturesSetting',
    method: 'post',
    data: data
  });
}
// 期权交易
export function optionOrder(data) {
  return fetch({
    url: '/api/user/option-order',
    method: 'post',
    data: data
  });
}
// 模拟期权交易
export function imitateOptionOrder(data) {
  return fetch({
    url: '/api/user/virtual-option-order',
    method: 'post',
    data: data
  });
}
// 期权订单
export function optionOrderList(data) {
  return fetch({
    url: '/api/user/option-order-lists',
    method: 'post',
    data: data
  });
}
// 模拟期权订单
export function imitateOptionOrderList(data) {
  return fetch({
    url: '/api/user/virtual-option-order-lists',
    method: 'post',
    data: data
  });
}
// K线图
export function kLine(data) {
  return fetch({
    url: '/api/user/k-line',
    method: 'post',
    data: data
  });
}
// 合约下单
export function contractOrder(data) {
  return fetch({
    url: '/api/user/contract-order',
    method: 'post',
    data: data
  });
}
// 模拟合约下单
export function imitateContractOrder(data) {
  return fetch({
    url: '/api/user/virtual-contract-order',
    method: 'post',
    data: data
  });
}
// 合约订单
export function contractList(data) {
  return fetch({
    url: '/api/user/contract-list',
    method: 'post',
    data: data
  });
}
// 模拟合约订单
export function imitateContractList(data) {
  return fetch({
    url: '/api/user/virtual-contract-list',
    method: 'post',
    data: data
  });
}
// 合约订单更改止盈止损
export function contractSpot(data) {
  return fetch({
    url: '/api/user/contract-stop',
    method: 'post',
    data: data
  });
}
// 模拟合约订单更改止盈止损
export function imitateContractSpot(data) {
  return fetch({
    url: '/api/user/virtual-contract-stop',
    method: 'post',
    data: data
  });
}
// 合约订单平仓
export function contractLiquidation(data) {
  return fetch({
    url: '/api/user/contract-liquidation',
    method: 'post',
    data: data
  });
}
// 模拟合约订单平仓
export function imitateContractLiquidation(data) {
  return fetch({
    url: '/api/user/virtual-contract-liquidation',
    method: 'post',
    data: data
  });
}
// 交易设置
export function tradeSetting(data) {
  return fetch({
    url: '/api/user/transaction-settings-lists',
    method: 'post',
    data: data
  });
}
// 修改交易设置
export function updateTradeSetting(data) {
  return fetch({
    url: '/api/user/transaction-settings-update',
    method: 'post',
    data: data
  });
}

// 跟单交易员列表
export function copyTradeList(data) {
  return fetch({
    url: '/api/user/copy-trading-settings-lists',
    method: 'post',
    data: data
  });
}
// 跟单加入
export function copyTradeJoin(data) {
  return fetch({
    url: '/api/user/copy-trading-records-add',
    method: 'post',
    data: data
  });
}
// 我的交易员
export function copyTradeLog(data) {
  return fetch({
    url: '/api/user/copy-trading-records-lists',
    method: 'post',
    data: data
  });
}
// 模拟资产
export function imitateWallet(data) {
  return fetch({
    url: '/api/user/virtual-wallet-list',
    method: 'post',
    data: data
  });
}
// 跟单收益
export function copyTradeStatistics(data) {
  return fetch({
    url: '/api/user/copy-trading-records-overview',
    method: 'post',
    data: data
  });
}
// 跟单列表
export function copyTradeOrderList(data) {
  return fetch({
    url: '/api/user/copy-option-order-lists',
    method: 'post',
    data: data
  });
}
// 交易员申请
export function traderApply(data) {
  return fetch({
    url: '/api/user/trader-application-records-add',
    method: 'post',
    data: data
  });
}
// 交易概况
export function traderOverview(data) {
  return fetch({
    url: '/api/user/trade-overview',
    method: 'post',
    data: data
  });
}
// 关注列表
export function bitFollowList(data) {
  return fetch({
    url: '/api/user/follow-lists',
    method: 'post',
    data: data
  });
}
// 关注添加
export function bitFollowAdd(data) {
  return fetch({
    url: '/api/user/follow-add',
    method: 'post',
    data: data
  });
}
// 关注删除
export function bitFollowRemove(data) {
  return fetch({
    url: '/api/user/follow-del',
    method: 'post',
    data: data
  });
}
// 用户报表
export function accountReport(data) {
  return fetch({
    url: '/api/user/report-lists',
    method: 'post',
    data: data
  });
}
